module.exports = __webpack_public_path__ + "img/valance-scallop-short.151486ea.svg";